"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flag = void 0;
var React = __importStar(require("react"));
var CountriesByCode_1 = __importDefault(require("./CountriesByCode"));
var react_country_flag_1 = __importDefault(require("react-country-flag"));
var styled_components_1 = __importDefault(require("styled-components"));
var FlagUrl = 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/flags/4x3/';
var DEFAULT_STYLE = {
    height: 13,
    width: 24,
};
var Flag = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.countryCode, countryCode = _c === void 0 ? 'US' : _c, _d = _a.style, style = _d === void 0 ? DEFAULT_STYLE : _d, rest = __rest(_a, ["className", "countryCode", "style"]);
    var code = countryCode.toUpperCase();
    var name;
    if (code === 'UK') {
        code = 'GB';
        name = CountriesByCode_1.default['GB'];
    }
    else {
        name = CountriesByCode_1.default[code];
    }
    if (!name) {
        code = 'US';
        name = CountriesByCode_1.default['US'];
    }
    return (React.createElement(StyledFlag, __assign({ alt: name, "aria-label": name, cdnUrl: FlagUrl, className: className, countryCode: code, style: style, svg: true }, rest)));
};
exports.Flag = Flag;
exports.default = React.memo(exports.Flag);
var StyledFlag = (0, styled_components_1.default)(react_country_flag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-block;\n"], ["\n    display: inline-block;\n"])));
var templateObject_1;
